import { render, staticRenderFns } from "./RepairRequestTab.vue?vue&type=template&id=cd4bf4aa&"
import script from "./RepairRequestTab.vue?vue&type=script&lang=ts&"
export * from "./RepairRequestTab.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cd4bf4aa')) {
      api.createRecord('cd4bf4aa', component.options)
    } else {
      api.reload('cd4bf4aa', component.options)
    }
    module.hot.accept("./RepairRequestTab.vue?vue&type=template&id=cd4bf4aa&", function () {
      api.rerender('cd4bf4aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/building/components/RepairRequestTab.vue"
export default component.exports